export const environment = {
    apiUrl:"https://api.skillproof.hu/api",
    apiUrls:{
        login:"https://api.skillproof.hu/api/User/Login",
        register:"https://api.skillproof.hu/api/User/Register",
        getProfile:"https://api.skillproof.hu/api/User",
        updateUser:"https://api.skillproof.hu/api/User",
        getProfileTests:"https://api.skillproof.hu/api/User/UserTests",
        getJobsOfCompany:"https://api.skillproof.hu/api/Jobs/jobsOfCompany",
        updateSkills:"https://api.skillproof.hu/api/User/UpdateSkills"
    }
};
